import request from '@/utils/request'

export function queryDemanddepart(params) {
  return request({
    url: '/mall/mallmanage/demanddepart/queryDemanddepart',
    method: 'post',
    params
  })
}

export function queryDemanddepartChildren(params) {
  return request({
    url: '/mall/mallmanage/demanddepart/queryDemanddepartChildren',
    method: 'post',
    params
  })
}

export function acceptDemanddepart(params) {
  return request({
    url: '/mall/mallmanage/demanddepart/acceptDemanddepart',
    method: 'post',
    params
  })
}

export function deleteDemanddepart(params) {
  return request({
    url: '/mall/mallmanage/demanddepart/deleteDemanddepart',
    method: 'post',
    params
  })
}

